import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/Client/Sidebar/Sidebar";
import ProductList from "../../components/Shared/ProductList/ProductList";
import "./ProductsPage.css";

// Imágenes de productos
import product1 from "../../components/Client/assets/product1.png";
import product2 from "../../components/Client/assets/product2.png";
import product3 from "../../components/Client/assets/product3.png";
import product4 from "../../components/Client/assets/product4.png";
import product5 from "../../components/Client/assets/product5.png";
import product6 from "../../components/Client/assets/product6.png";

const categories = ["Merchandising", "Snow", "Hogar"];


// Lista de imágenes para asignarlas aleatoriamente
const productImages = [product1, product2, product3, product4, product5, product6];

const ProductsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const selectedCategory = queryParams.get("category");

  const [filteredProducts, setFilteredProducts] = useState([]);
  const [products] = useState(
    Array.from({ length: 60 }, (_, index) => ({
      id: index + 1,
      name: `Producto ${index + 1}`,
      price: parseFloat((Math.random() * 50 + 10).toFixed(2)), // Precio como número
      category: categories[index % categories.length],
      description: `Esta es una descripción detallada para el Producto ${index + 1}. Aquí puedes agregar especificaciones, características y beneficios del producto.`,
      image: productImages[index % productImages.length], // Asignar imagen basada en el índice
    }))
  );

  useEffect(() => {
    if (selectedCategory) {
      setFilteredProducts(products.filter((product) => product.category === selectedCategory));
    } else {
      setFilteredProducts(products);
    }
  }, [selectedCategory, products]);

  const handleFilterCategory = (category) => {
    navigate(`/productos?category=${category}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="products-page">
      <Sidebar
        onFilterCategory={handleFilterCategory}
        onFilterPrice={(price) => {
          setFilteredProducts(
            products.filter((product) => product.price <= parseFloat(price))
          );
        }}
      />
      <div className="products-content">
        <h2 className="category-title">
          {selectedCategory ? `Categoría: ${selectedCategory}` : "Todos los productos"}
        </h2>
        <ProductList products={filteredProducts} />
      </div>
    </div>
  );
};

export default ProductsPage;
